module.exports = __webpack_public_path__ + "img/moto-picture.cd355295.svg";